import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';

export const headers: Record<string, EnhancedTableHeader> = {
  PolicyCover: {
    name: 'PolicyCover',
    title: 'Policy Cover',
    type: EnhancedTableHeaderType.Text,
  },
  IsMandatory: {
    name: 'IsMandatory',
    title: 'Mandatory',
    type: EnhancedTableHeaderType.Text,
  },
  EffectiveFrom: {
    name: 'EffectiveFrom',
    title: 'Effective From',
    type: EnhancedTableHeaderType.Date,
  },
  EffectiveTo: {
    name: 'EffectiveTo',
    title: 'Effective To',
    type: EnhancedTableHeaderType.Date,
  },
  CoverSumInsured: {
    name: 'CoverSumInsured',
    title: 'Sum Insured',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  SumInsuredIsAdditive: {
    name: 'SumInsuredIsAdditive',
    title: 'Additive Sum Insured',
    type: EnhancedTableHeaderType.Text,
  },
  AmendmentCoverSumInsured: {
    name: 'AmendmentCoverSumInsured',
    title: 'Sum Insured Variance',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  CoverPremiumValue: {
    name: 'CoverPremiumValue',
    title: 'Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  AmendmentCoverPremiumValue: {
    name: 'AmendmentCoverPremiumValue',
    title: 'Premium Variance',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  Excess: {
    name: 'Excess',
    title: 'Excess',
    type: EnhancedTableHeaderType.Text,
  },
  ExcessVariance: {
    name: 'ExcessVariance',
    title: 'Excess Variance',
    type: EnhancedTableHeaderType.Text,
  },
};
